class Stack {
    constructor() {
        this.stack = []
        this.max = 0
        this.opts = {
            '+': 1,
            '-': 1,
            '*': 5,
            '/': 5,
            '(': 10,
            ')': 10
        }
    }
    in(char) {
        this.stack.push(char)
        this.max = this.opts[this.stack[this.stack.length - 1]]
    }
    out() {
        let pop = this.stack.pop()
        this.max = this.opts[this.stack[this.stack.length - 1]]
        return pop
    }
    empty() {
        return !this.stack.length
    }
    last() {
        return this.stack[this.stack.length - 1]
    }
}
// 中序转后序
function transform(str) {
    // 模拟栈 存储运算操作符
    var stack = new Stack()
    // 后序表达式数组
    var postfixExp = []

    try {
        // 切分中序表达式
        str = str2arr(str)
        // 遍历处理过后的中序表达式
        for (let i = 0; i < str.length; i++) {
            // debugger
            let item = str[i]
            if (!isNaN(Number(item))) { // 数字直接入栈
                postfixExp.push(item)
            } else if (item === '(') { // '(' 直接入栈
                stack.in(item)
            } else if (item === ')') { // 遇到 ')' 则持续出栈至遇到'('停止
                let top = stack.out()
                while (top && top !== '(') {
                    postfixExp.push(top)
                    top = stack.out()
                }
            } else if (stack.opts[item]) { // 合法的 加减乘除字符
                if (stack.empty() || stack.opts[item] > stack.max || stack.last() === '(') {
                    // 栈为空 || 当前运算符优先级较高 || 栈顶是'('字符 
                    stack.in(item)
                } else {
                    // 栈顶元素依次出栈 直至新操作符比栈顶优先级高 新操作符入栈
                    let top = stack.last() // 目前栈顶的元素
                    let max = stack.opts[item] // 新操作符的权重
                    while (top && max <= stack.max && stack.last() !== '(') {
                        postfixExp.push(stack.out())
                        top = stack.last()
                    }
                    stack.in(item)
                }
            }
        }

        // 遍历结束 输出栈中所有�元素
        while (!stack.empty()) {
            postfixExp.push(stack.out())
        }

        return postfixExp
    }
    catch (e) {
        return ""
    }
}
function str2arr(str) {
    str = str.split('+').join('|+|')
    str = str.split('-').join('|-|')
    str = str.split('*').join('|*|')
    str = str.split('/').join('|/|')
    str = str.split('(').join('(|')
    str = str.split(')').join('|)')
    return str.split('|')
}
// 后序表达式计算得出结果
function getResult(arr) {
    // 模拟栈 存储运算数字
    let stack = new Stack()
    for (let i = 0; i < arr.length; i++) {
        let item = arr[i]
        if (!isNaN(Number(item))) { // 数字直接入栈
            stack.in(item)
        } else { // 遇到操作符 则拿出栈顶的两个元素 进行运算 并将运算结果入栈
            let tempRes = 0
            let a = Number(stack.out())
            let b = Number(stack.out())
            switch (item) {
                case '+': tempRes = b + a; break;
                case '-': tempRes = b - a; break;
                case '*': tempRes = b * a; break;
                case '/': tempRes = b / a; break;
                default: throw new Error('操作符有误')
            }
            stack.in(tempRes)
        }
    }
    return stack.out()
}
function trtdToExp(columns, data) {
    const reg = /d[0-9]*/g;
    for (let i = 0; i < columns.length; i++) {
        let str = columns[i].defaultValue.value;
        if (columns[i].defaultValue.style == 0 && str.match("exp=*")) {
            str = str.replace("exp=", "")
            let arrReg = str.match(reg);

            for (let j = 0; j < data.length; j++) {
                let expStr = str
                const row = data[j];
                for (let k = 0; k < arrReg.length; k++) {
                    let element = arrReg[k];
                    //获取代表的数据
                    const d = element.replace('d', "");
                    expStr = expStr.replace(arrReg[k], row[d]);
                }
                const strExp2 = transform(expStr)
                if (strExp2.length == 0) {
                    data[j][i + 1] = "-"
                }
                else {
                    let value = getResult(strExp2) + ''
                    data[j][i + 1] = value == "NaN" || value == "Infinity" ? "-" : value;
                }
            }
        }
    }
    return data;
}

function trtdToExp2(columns, data) {
    const reg = /d[0-9]*/g;
    for (let i = 1; i < columns.length; i++) {
        let str = columns[i].defaultValue.value;
        if (columns[i].defaultValue.style == 0 && str.match("exp=*")) {
            str = str.replace("exp=", "")
            let arrReg = str.match(reg);

            for (let j = 1; j < data.length; j++) {
                let expStr = str
                const row = data[j];
                for (let k = 0; k < arrReg.length; k++) {
                    let element = arrReg[k];
                    //获取代表的数据
                    const d = element.replace('d', "");
                    expStr = expStr.replace(arrReg[k], row[Number(d) + 1]);
                }
                const strExp2 = transform(expStr)
                if (strExp2.length == 0) {
                    data[j][i + 1] = "-"
                }
                else {
                    let value = getResult(strExp2) + ''
                    data[j][i + 1] = value == "NaN" || value == "Infinity" ? "-" : value;
                }
            }
        }
    }
    return data;
}

export default { trtdToExp, trtdToExp2 }